import { render, staticRenderFns } from "./DiscordPremiumButton.vue?vue&type=template&id=8c30e4da&scoped=true"
import script from "./DiscordPremiumButton.vue?vue&type=script&lang=js"
export * from "./DiscordPremiumButton.vue?vue&type=script&lang=js"
import style0 from "./DiscordPremiumButton.vue?vue&type=style&index=0&id=8c30e4da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c30e4da",
  null
  
)

export default component.exports